import { CreateChallengeError, CreateChallengeErrorCodes } from './create-challenge-error';
import { ErrorActions, ErrorData } from '../../../../types';

// This file is a POC for the proposal of this document: https://docs.google.com/document/d/18pthm7FLbHDcMZYogpSCN-DYeOJOpoK6NdLl39r_QKc/edit#

const getCreateChallengeErrorData = (error: CreateChallengeError.ErrorWrapper): ErrorData => {
  const errorBody: CreateChallengeError.ErrorTypes = error?.error;

  const DefaultAcceptAction = { type: 'primary', action: ErrorActions.Close, text: { id: 'errorAlert.primary.text' } };

  switch (errorBody.code) {
    case CreateChallengeErrorCodes.InsufficientPermissions: {
      return {
        title: { id: 'common.errors.opposition.insufficientPermissions.title' },
        message: { id: 'common.errors.challenge.insufficientPermissions.message' },
        onCloseAction: ErrorActions.Close,
        actions: [
          {
            type: 'secondary',
            text: { id: 'common.errors.opposition.insufficientPermissions.freeTrialAction.title' },
            action: ErrorActions.FreeTrial,
          },
          {
            type: 'primary',
            text: { id: 'common.errors.opposition.insufficientPermissions.subscribeAction.title' },
            action: ErrorActions.Subscribe,
          },
        ],
      };
    }

    case CreateChallengeErrorCodes.StartDateLessThanNow: {
      return {
        title: { id: 'common.errors.challenge.startDateLessThanNow.title' },
        message: { id: 'common.errors.challenge.startDateLessThanNow.message' },
        onCloseAction: ErrorActions.Close,
        actions: [
          {
            type: 'primary',
            text: { id: 'common.errors.challenge.startDateLessThanNow.ok.button' },
            action: ErrorActions.Close,
          },
        ],
      };
    }

    default: {
      return {
        title: { id: 'createChallenge.error.default.title' },
        message: { id: 'common.errors.default.message' },
        value: { code: errorBody.code },
        onCloseAction: ErrorActions.Close,
        actions: [DefaultAcceptAction],
        isUnknownError: true,
      };
    }
  }
};

export default getCreateChallengeErrorData;
